import React from "react";

export default () => {
  return (
    <div className="label-content">
      <h4>Game Settings</h4>
    </div>
  );
};
